import React, { ReactNode } from 'react';
import './Card.scss';

interface CardProps {
  title?: ReactNode;
  body: ReactNode;
  hidden?: boolean;
}

// Updated component with proper typing and scoped styling
const Card = ({ title, body, hidden = false }: CardProps) =>
  !hidden ? (
    <div className="cardComponent">
      {title && <div className="cardTitle">{title}</div>}
      <div className="cardBody">{body}</div>
    </div>
  ) : null;

export default Card;
